module.exports = __webpack_public_path__ + "media/servicesPages/listIcon3-07aeb69f.png";